/* OBLISH JS v9 — All bugs fixed
   BUG FIX 1: HeroFastStart() REMOVED — hero manages its own ob-ready
   BUG FIX 2: KillDawnAnimations() — neutralises Dawn animations.js conflict
   BUG FIX 3: No double animation, no fly-in glitch
*/
(function(){
'use strict';
var SHIP=99900;

/* KILL DAWN ANIMATIONS — must run before anything else */
function KillDawnAnimations(){
  var s=document.createElement('style');
  s.id='ob-dawn-kill';
  s.textContent=[
    '.scroll-trigger{opacity:1!important;transform:none!important;transition:none!important;animation:none!important;}',
    '.scroll-trigger--offscreen{opacity:1!important;transform:none!important;}',
    '.animate--slide-in{animation:none!important;opacity:1!important;transform:none!important;}',
    '.animate--slide-in-from-right{animation:none!important;opacity:1!important;transform:none!important;}',
    '[data-cascade]{opacity:1!important;transform:none!important;}'
  ].join('');
  document.head.appendChild(s);
  /* Also remove classes from existing elements */
  function strip(){
    document.querySelectorAll('.scroll-trigger,.animate--slide-in,.animate--slide-in-from-right').forEach(function(el){
      el.classList.remove('scroll-trigger','animate--slide-in','animate--slide-in-from-right');
    });
  }
  strip();
  setTimeout(strip,200);
  setTimeout(strip,600);
}

/* IMAGE CLICK FIX */
function FixCardClicks(){
  document.querySelectorAll('.card-wrapper,.product-card-wrapper').forEach(function(w){
    if(w.dataset.obClick)return;
    w.dataset.obClick='1';
    var url=null;
    w.querySelectorAll('a[href]').forEach(function(a){
      if(!url&&a.href&&a.href.indexOf('/products/')>-1)url=a.href;
    });
    if(!url)return;
    w.style.cursor='pointer';
    w.addEventListener('click',function(e){
      if(e.target.closest('a,button,form'))return;
      window.location.href=url;
    });
  });
}

/* FREE SHIPPING BAR */
function ShipBar(){
  var bar=document.getElementById('ob-ship-bar');
  if(!bar)return;
  var txt=document.getElementById('ob-ship-text');
  var fill=document.getElementById('ob-ship-fill');
  function update(t){
    if(t===0){bar.classList.add('is-hidden');return;}
    bar.classList.remove('is-hidden');
    if(t>=SHIP){
      bar.classList.add('is-unlocked');
      if(fill)fill.style.width='100%';
    } else {
      bar.classList.remove('is-unlocked');
      if(txt)txt.innerHTML='Add <strong>\u20b9'+Math.ceil((SHIP-t)/100)+'</strong> more for FREE shipping';
      if(fill)fill.style.width=Math.round((t/SHIP)*100)+'%';
    }
  }
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){update(c.total_price);}).catch(function(){bar.classList.add('is-hidden');});
  document.addEventListener('cart:updated',function(e){if(e.detail&&e.detail.cart)update(e.detail.cart.total_price);});
}

/* CART PULSE */
function CartPulse(){
  var b=document.querySelector('.cart-count-bubble');
  if(!b)return;
  new MutationObserver(function(){
    b.classList.remove('pulse');void b.offsetWidth;b.classList.add('pulse');
  }).observe(b,{childList:true,subtree:true,characterData:true});
}

/* RECENTLY VIEWED */
function RecentlyViewed(){
  var KEY='ob_rv',MAX=8;
  function get(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return[];}}
  function save(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  var pdp=document.querySelector('[data-product-handle]');
  if(pdp){
    var h=pdp.dataset.productHandle;
    var imgEl=document.querySelector('#ob-main-img,.product__media img');
    if(h){
      var list=get().filter(function(p){return p.handle!==h;});
      list.unshift({handle:h,title:pdp.dataset.productTitle||'',img:imgEl?imgEl.src:'',url:window.location.pathname});
      save(list.slice(0,MAX));
    }
  }
  var grid=document.getElementById('ob-rv-grid');
  if(!grid)return;
  var cur=pdp?pdp.dataset.productHandle:null;
  var filtered=get().filter(function(p){return p.handle!==cur;}).slice(0,4);
  if(!filtered.length){var s=document.getElementById('ob-rv-sec');if(s)s.style.display='none';return;}
  grid.innerHTML=filtered.map(function(p){
    return '<a href="'+p.url+'" class="ob-rv-item"><div class="ob-rv-item__img"><img src="'+p.img+'" alt="'+p.title+'" loading="lazy"></div><div class="ob-rv-item__name">'+p.title+'</div></a>';
  }).join('');
}

/* CURSOR */
function Cursor(){
  if(window.matchMedia('(pointer:coarse)').matches)return;
  var dot=document.createElement('div');dot.className='ob-cur';
  var ring=document.createElement('div');ring.className='ob-ring';
  document.body.append(dot,ring);
  var mx=0,my=0,rx=0,ry=0;
  window.addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;dot.style.left=mx+'px';dot.style.top=my+'px';},{passive:true});
  (function tick(){rx+=(mx-rx)*0.11;ry+=(my-ry)*0.11;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(tick);})();
  document.addEventListener('mouseover',function(e){
    var ov=e.target.closest('a,button,.card-wrapper,.ob-hbtn');
    dot.classList.toggle('hov',!!ov);
    ring.classList.toggle('hov',!!ov);
  });
}

/* SCROLL PROGRESS */
function Progress(){
  var b=document.createElement('div');b.className='ob-prog';document.body.prepend(b);
  window.addEventListener('scroll',function(){
    b.style.width=Math.min(window.scrollY/(document.body.scrollHeight-window.innerHeight)*100,100)+'%';
  },{passive:true});
}

/* HEADER SOLID ON SCROLL */
function Header(){
  var h=document.querySelector('.header-wrapper');if(!h)return;
  window.addEventListener('scroll',function(){h.classList.toggle('solid',window.scrollY>80);},{passive:true});
}

/* SCROLL REVEAL — our own, clean */
function Reveal(){
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      var el=e.target;
      el.classList.remove('scroll-trigger');
      var idx=Array.from(el.parentElement.children).indexOf(el)%6;
      if(idx>0)el.style.transitionDelay=(idx*0.055)+'s';
      el.classList.add('vis');
      io.unobserve(el);
    });
  },{threshold:0.06,rootMargin:'0px 0px -24px 0px'});
  document.querySelectorAll('.card-wrapper,.collection-card-wrapper,.ob-feature,[data-ob]:not(.vis)').forEach(function(el){
    el.classList.remove('scroll-trigger');
    if(!el.classList.contains('vis')){el.setAttribute('data-ob','');io.observe(el);}
  });
}

/* SCROLL TO TOP */
function ScrollTop(){
  var btn=document.createElement('button');
  btn.className='ob-totop';btn.innerHTML='&uarr;';btn.setAttribute('aria-label','Back to top');
  document.body.appendChild(btn);
  window.addEventListener('scroll',function(){btn.classList.toggle('show',window.scrollY>600);},{passive:true});
  btn.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
}

/* MARQUEE */
function Marquee(){
  document.querySelectorAll('.ob-marquee__track').forEach(function(t){
    if(!t.dataset.duped){t.innerHTML+=t.innerHTML;t.dataset.duped='1';}
  });
}

/* DISCOUNT BADGES */
function Badges(){
  document.querySelectorAll('.card-wrapper').forEach(function(c){
    if(c.querySelector('.ob-badge'))return;
    var prices=[];
    c.querySelectorAll('.money').forEach(function(m){
      var v=parseFloat(m.textContent.replace(/[^0-9.]/g,''));if(v>0)prices.push(v);
    });
    if(prices.length<2)return;
    var lo=Math.min.apply(null,prices),hi=Math.max.apply(null,prices);
    if(hi<=lo||lo<=0)return;
    var pct=Math.round((1-lo/hi)*100);if(pct<5)return;
    var b=document.createElement('div');b.className='ob-badge';b.textContent='-'+pct+'%';
    var m=c.querySelector('.card__media');if(m){m.style.position='relative';m.appendChild(b);}
  });
}

/* PAGE TRANSITION */
function Transition(){
  var ov=document.getElementById('ob-transition');if(!ov)return;
  document.addEventListener('click',function(e){
    var a=e.target.closest('a');
    if(!a||!a.href||a.href===location.href||a.href.startsWith('#')||a.target==='_blank'||a.hostname!==location.hostname)return;
    e.preventDefault();
    var dest=a.href;
    ov.style.cssText='transition:opacity 0.22s ease;opacity:1;pointer-events:all;';
    setTimeout(function(){location.href=dest;},220);
  });
  window.addEventListener('pageshow',function(){
    ov.style.cssText='transition:opacity 0.4s ease;opacity:0;pointer-events:none;';
  });
}

/* ANNOUNCEMENT BAR */
function AnnounceFix(){
  var bar=document.querySelector('.announcement-bar-slider');if(!bar)return;
  var slides=Array.from(bar.querySelectorAll('.slideshow__slide'));
  if(slides.length<2)return;
  slides.forEach(function(s,i){
    Object.assign(s.style,{position:i===0?'relative':'absolute',top:'0',left:'0',width:'100%',opacity:i===0?'1':'0',transition:'opacity 0.4s ease',pointerEvents:i===0?'auto':'none'});
  });
  var cur=0;
  function go(n){
    slides[cur].style.opacity='0';slides[cur].style.pointerEvents='none';slides[cur].style.position='absolute';
    slides[n].style.position='relative';slides[n].style.opacity='1';slides[n].style.pointerEvents='auto';
    cur=n;
  }
  var prev=bar.querySelector('[name="previous"]'),nxt=bar.querySelector('[name="next"]');
  if(prev)prev.addEventListener('click',function(e){e.stopImmediatePropagation();go((cur-1+slides.length)%slides.length);},true);
  if(nxt)nxt.addEventListener('click',function(e){e.stopImmediatePropagation();go((cur+1)%slides.length);},true);
  setInterval(function(){go((cur+1)%slides.length);},5500);
}

/* FOOTER ACCORDION */
function FooterAccordion(){
  document.querySelectorAll('.ob-footer__acc-btn').forEach(function(btn){
    if(btn.dataset.bound)return;
    btn.dataset.bound='1';
    btn.addEventListener('click',function(){
      var body=btn.nextElementSibling,isOpen=btn.classList.contains('is-open');
      document.querySelectorAll('.ob-footer__acc-btn.is-open').forEach(function(b){
        b.classList.remove('is-open');b.setAttribute('aria-expanded','false');
        b.nextElementSibling.classList.remove('is-open');
      });
      if(!isOpen){btn.classList.add('is-open');btn.setAttribute('aria-expanded','true');body.classList.add('is-open');}
    });
  });
}

/* INIT */
function init(){
  /* Run immediately — kill Dawn animations before they apply */
  KillDawnAnimations();
  Cursor();
  Progress();
  Header();
  Marquee();
  AnnounceFix();
  ShipBar();
  CartPulse();
  Transition();
  FooterAccordion();

  setTimeout(function(){
    KillDawnAnimations(); /* run again after Dawn scripts load */
    RecentlyViewed();
    Reveal();
    ScrollTop();
    Badges();
    FixCardClicks();
  },150);

  setTimeout(function(){
    KillDawnAnimations();
    Reveal();
    Badges();
    FixCardClicks();
  },700);

  setTimeout(function(){
    Reveal();
    FixCardClicks();
  },2000);
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',init);
}else{
  init();
}

document.addEventListener('shopify:section:load',function(){
  setTimeout(function(){
    KillDawnAnimations();Reveal();Badges();FixCardClicks();ShipBar();FooterAccordion();
  },200);
});

})();
